import { Input, ElementRef, Renderer2, ChangeDetectorRef, HostBinding } from '@angular/core';
import { ContextMenuService } from 'ngx-contextmenu';
import { NgxExcelColumn, NgxExcelColumnType } from '../models/models';

export abstract class NgxExcelCellInterface {

  componentSence: 'list' | 'table';

  private _compact = false;

  @Input() column: NgxExcelColumn;
  @Input()
  set compact(value: boolean) { this._compact = value === false ? false : true; }
  get compact(): boolean { return this._compact; }
  @HostBinding('class.ngx-excel-cell') excelCellClass = true;

  constructor(
    protected el: ElementRef,
    protected renderer2: Renderer2,
    protected cdr: ChangeDetectorRef,
    protected contextMenuService: ContextMenuService
  ) { }

  /**
   * æ³¨åå½ååºæ¯é£æ ¼
   * @param scene å½ååºæ¯
   */
  public registerScene(scene: 'list' | 'table' | 'compact') {
    this._compact = scene === 'compact';
    this.componentSence = scene === 'list' ? 'list' : 'table';

    if (this.componentSence === 'table') {
      if (this.column.columnType === NgxExcelColumnType.UploadFile || this.column.columnType === NgxExcelColumnType.MultiUploadFile) {
        this.renderer2.addClass(this.el.nativeElement, 'ngx-excel-cell--table-upload');
      } else if (this.column.columnType === NgxExcelColumnType.MultilineText) {
        this.renderer2.addClass(this.el.nativeElement, 'ngx-excel-cell--table-multiline-text');
      }
    }
  }

}
